import aguid from 'lib/aguid';
import STORE from 'store';

const createExportSavedFilter = async ({
  source,
  dateField,
  currentScope,
  currentDrillDowns,
  relativeDateRange,
  dateRange,
  advancedRelativeDateRange,
  accountId,
}: {
  source: 'report-export' | 'report-schedule';
  dateField: string;
  currentScope: FilterPlateType[];
  currentDrillDowns: FilterPlateType[];
  relativeDateRange: RelativeDateRange | undefined;
  dateRange: DateRangeInput | undefined;
  advancedRelativeDateRange: AdvancedRelativeDateRange | undefined;
  accountId: string;
}): Promise<string> => {
  const sf: LegacySavedFilter = {
    version: '2',
    source,
    dateField,
    id: aguid(),
    scope: currentScope,
    drillDowns: currentDrillDowns,
    relativeDateRange,
    dateRange,
    advancedRelativeDateRange,
  };

  await STORE.filterDefinitions
    .getLegacySavedFiltersRef({ accountId })
    .doc(sf.id)
    .set(sf);

  return sf.id;
};

export default createExportSavedFilter;
